import update from 'immutability-helper';
import {
  GET_GROUPTRIP_LIST_SUCCESS,
  GET_NEXT_GROUPTRIP_LIST_SUCCESS,
  GET_GROUPTRIP_LIST_LOADING,
  SHOW_SHARE_GROUPTRIP_BOX,
  CLOSE_SHARE_GROUPTRIP_BOX,
  POST_GROUPTRIP_PUBLIC_STATUS_SUCCESS,
  SHOW_WATCH_GROUP_BOX,
  CLOSE_WATCH_GROUP_BOX,
  DELETE_GROUPTRIP_SUCCESS,
  DELETE_GROUPTRIP_FAIL,
  SET_GROUPTRIP_ITEM_LOADING,
  RESET_MYTRIP_PAGE_STATE,
} from '../actions/action_types';

export default (
  state = {
    currentTrip: {},
    loadingTripID: '',
    isShowWatchGroupBox: false,
    isShowShareTripBox: false,
    tripData: [],
    hasMore: false,
    membersOfGroup: {
      members: [],
      owner: {},
    },
  },
  action,
) => {
  switch (action.type) {
    case GET_GROUPTRIP_LIST_SUCCESS:
      return {
        ...state,
        totalCount: action.payload.totalCount,
        skip: action.payload.skip,
        tripData: action.payload.trips,
        hasMore: action.payload.totalCount > action.payload.trips.length,
      };
    case GET_NEXT_GROUPTRIP_LIST_SUCCESS:
      return {
        ...state,
        totalCount: action.payload.totalCount,
        skip: action.payload.skip,
        tripData: [...state.tripData, ...action.payload.trips],
        hasMore:
          action.payload.totalCount >
          state.tripData.length + action.payload.trips.length,
      };
    case GET_GROUPTRIP_LIST_LOADING:
      return {
        currentTrip: {},
        loadingTripID: '',
        isShowWatchGroupBox: false,
        isShowShareTripBox: false,
        tripData: [],
        hasMore: false,
        membersOfGroup: {
          members: [],
          owner: {},
        },
      };
    case SHOW_SHARE_GROUPTRIP_BOX:
      return {
        ...state,
        currentTrip: action.payload,
        isShowShareTripBox: true,
      };
    case CLOSE_SHARE_GROUPTRIP_BOX:
      return {
        ...state,
        currentTrip: {},
        isShowShareTripBox: false,
      };
    case POST_GROUPTRIP_PUBLIC_STATUS_SUCCESS:
      return setPublicChangeTripData(state, action.payload);
    case SHOW_WATCH_GROUP_BOX:
      return {
        ...state,
        isShowWatchGroupBox: true,
        loadingTripID: '',
        currentTrip: action.payload.trip,
        membersOfGroup: action.payload.membersOfGroup,
      };
    case CLOSE_WATCH_GROUP_BOX:
      return {
        ...state,
        isShowWatchGroupBox: false,
        loadingTripID: '',
        currentTrip: {},
        membersOfGroup: {
          members: [],
          owner: {},
        },
        invitationLink: '',
      };
    case DELETE_GROUPTRIP_SUCCESS:
      return deleteGroupTrip(state, action.payload);
    case DELETE_GROUPTRIP_FAIL:
      return {
        ...state,
        loadingTripID: '',
        currentTrip: {},
      };
    case SET_GROUPTRIP_ITEM_LOADING:
      return {
        ...state,
        loadingTripID: action.payload,
      };
    case RESET_MYTRIP_PAGE_STATE:
      return {
        currentTrip: {},
        loadingTripID: '',
        isShowWatchGroupBox: false,
        isShowShareTripBox: false,
        tripData: [],
        hasMore: false,
        membersOfGroup: {
          members: [],
          owner: {},
        },
      };
    default:
      return state;
  }
};

const setPublicChangeTripData = (state, payload) => {
  const index = state.tripData.findIndex(item => item._id === payload.tripID);
  const newTripData = [...state.tripData];
  newTripData[index].publicStatus = payload.status;
  return {
    ...state,
    tripData: [...newTripData],
  };
};

const deleteGroupTrip = (state, payload) => {
  const deleteCount = 1; // 刪除數量

  const index = state.tripData.findIndex(item => item._id === payload);
  const newState = update(state, {
    tripData: { $splice: [[index, deleteCount]] },
  });
  return newState;
};
